"use strict";

import angular from "angular";

angular.module("nucont.accounting.companyCreate", ["nucont.shared"]);
require("./company-create.routes");
